import React, { Component } from "react";
import { connect } from "react-redux";

//Components
import ValueSlider from "./components/ValueSlider";

//MUI
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  List,
  Typography
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

//Icons
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

//Styles
const styles = theme => ({
  root: {
    heading: "2em"
  }
});

function mapStateToProps(state) {
  return {
    data: state.data.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

class Lights extends Component {
  state = {
    expanded: null,
    value: 0
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleExpandChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  generateSettings = (classes, expanded, data) => {
    console.log(data);
    const settings = Object.keys(data).map((a, i) => {
      return (
        <ExpansionPanel
          key={`${a}_${i}`}
          expanded={expanded === a}
          onChange={this.handleExpandChange(a)}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>{a}</Typography>
          </ExpansionPanelSummary>

          {Object.keys(data[`${a}`]).map((s, i) => {
            return s === "Lights" ? (
              <ExpansionPanelDetails key={`${s}_${a}`}>
                {
                  <ValueSlider
                    data={data[a][s][i]}
                    label="Adjust Lights"
                    dispatch={this.props.dispatch}
                  />
                }
              </ExpansionPanelDetails>
            ) : null;
          })}
        </ExpansionPanel>
      );
    });
    return <List component="nav">{settings}</List>;
  };

  render() {
    // eslint-disable-next-line
    const { classes, data } = this.props;
    const { expanded } = this.state;

    return <div>{this.generateSettings(classes, expanded, data)}</div>;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Lights));



// WEBPACK FOOTER //
// ./src/pages/user_dashboard/dashboard_tabs/Lights.js